const FETCH_PRIZE_TIERS_PENDING = "qwizme/prize_tier/FETCH";
const FETCH_PRIZE_TIERS_SUCCESS = "qwizme/prize_tier/FETCH_SUCCESS";
const FETCH_PRIZE_TIERS_FAIL = "qwizme/prize_tier/FETCH_FAIL";
const TOGGLE_PRIZE_SELECTION = "qwizme/prize_tier/TOGGLE_PRIZE_SELECTION";
const initialState = {
  prizeTiers: [],
  selectedPrizeId: null,
  pending: false,
  loaded: false,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PRIZE_TIERS_PENDING:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_PRIZE_TIERS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        prizeTiers: action.results.map(prize => {
          return {
            ...prize,
            prize_instance: undefined,
            price: -prize.prize_instance.cost
          };
        }),
        error: null
      });
    case FETCH_PRIZE_TIERS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });
    case TOGGLE_PRIZE_SELECTION:
      return Object.assign({}, state, {
        selectedPrizeId: state.selectedPrizeId === action.id ? null : action.id
      });
    default:
      return state;
  }
}

export function fetchPrizeTiersPending() {
  return {
    type: FETCH_PRIZE_TIERS_PENDING
  };
}

export function fetchPrizeTiersSuccess(results) {
  return {
    type: FETCH_PRIZE_TIERS_SUCCESS,
    results
  };
}

export function fetchPrizeTiersFail(error) {
  return {
    type: FETCH_PRIZE_TIERS_FAIL,
    error
  };
}

export function togglePrizeSelection(id) {
  return {
    type: TOGGLE_PRIZE_SELECTION,
    id
  };
}

export const getPrizeTiers = state => state.prizeTiers;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
export const getError = state => state.error;
export const getSelectedId = state => state.selectedPrizeId;
